<div class="form-container">
  <h2>{{ pageTitle }}</h2>
  <alert></alert>

  <form class="col-md-8 pl0" [formGroup]="partnerForm" (ngSubmit)="onSubmit()" novalidate>

    <div class="form-row">
      <div class="col-6">
        <!-- Partner Name -->
        <input type="text" class="form-control form-control-sm" formControlName="name" placeholder="Partner Name*"
          [ngClass]="{ 'is-invalid': submitted && partnerForm.controls.name.errors }" />
        @if (submitted && partnerForm.controls.name.errors) {
          <div class="text-danger">
            @if (partnerForm.controls.name.errors.required) {
              <div>Partner name is required</div>
            }
          </div>
        }
      </div>
      <div class="col-3">
        <!-- Partner URI -->
        <input type="text" class="form-control form-control-sm" formControlName="uri" placeholder="URI (lowercase)*"
          [ngClass]="{ 'is-invalid': submitted && partnerForm.controls.uri.errors }" />
        @if (submitted && partnerForm.controls.uri.errors) {
          <div class="text-danger">
            @if (partnerForm.controls.uri.errors.required) {
              <div>Partner URI is required</div>
            }
            @if (partnerForm.controls.uri.errors.alpha) {
              <div>Must be all lowercase</div>
            }
            @if (partnerForm.controls.uri.errors.lowercase) {
              <div>Must be letters only</div>
            }
          </div>
        }
      </div>
      <div class="col-3">
        <!-- Partner Status -->
        <select type="text" class="form-control form-control-sm" formControlName="status"
          [ngClass]="{ 'is-invalid': submitted && partnerForm.controls.status.errors }">
          <option value="" selected disabled>Status*</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
        @if (submitted && partnerForm.controls.status.errors) {
          <div class="text-danger">
            @if (partnerForm.controls.status.errors.required) {
              <div>Status is required</div>
            }
          </div>
        }
      </div>
    </div>

    <div class="form-row">
      <div class="col">
        <!-- Partner Email -->
        <input type="text" class="form-control form-control-sm" formControlName="email" placeholder="Email*"
          [ngClass]="{ 'is-invalid': submitted && partnerForm.controls.email.errors }" />
        @if (submitted && partnerForm.controls.email.errors) {
          <div class="text-danger">
            @if (partnerForm.controls.email.errors.required) {
              <div>Email is required</div>
            }
            @if (partnerForm.controls.email.errors.email) {
              <div>Email is invlalid</div>
            }
          </div>
        }
      </div>
      <div class="col">
        <!-- Phone Number -->
        <input class="form-control form-control-sm"
          [ngClass]="{ 'is-invalid': submitted && partnerForm.controls.phone.errors }" formControlName="phone"
          placeholder="Phone number (ex. +1 555 222 4444)">
        @if (submitted && partnerForm.controls.phone.errors) {
          <div class="text-danger">
            @if (partnerForm.controls.phone.errors.phone) {
              <div>Phone number is invalid (make sure to include country code)</div>
            }
          </div>
        }
      </div>
    </div>

    <div class="form-row">
      <div class="col">
        <!-- Partner Country -->
        <select type="text" class="form-control form-control-sm" formControlName="country"
          [ngClass]="{ 'is-invalid': submitted && partnerForm.controls.country.errors }">
          <option value="" selected disabled>Country*</option>
          @for (country of countries; track country) {
            <option [value]="country">{{ country }}</option>
          }
        </select>
        @if (submitted && partnerForm.controls.country.errors) {
          <div class="text-danger">
            @if (partnerForm.controls.country.errors.required) {
              <div>Country is required</div>
            }
          </div>
        }
      </div>
    </div>

    @if (!showReturnButton) {
      <div class="form-row">
        <button type="submit" class="btn btn-sm btn-primary" [disabled]="loading">{{ view === viewType.NEW ? 'Create' : 'Update' }} Partner</button>
        <button (click)="navigateBack()" [style.margin-left.px]="16" type="button" class="btn btn-sm btn-outline-secondary" [disabled]="loading">Cancel</button>
      </div>
    }
    @if (showReturnButton) {
      <div class="form-row">
        <button (click)="navigateBack()" type="button" class="btn btn-sm btn-primary">Done</button>
      </div>
    }

  </form>
</div>
